import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import SideNav from '../../shared/Sidenav';
import '../../../css/systemConfig/MaintainFunction.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import add from '../../../assets/images/add.svg';
import addDisable from '../../../assets/images/plus_disable.svg';
import Calendar from 'react-calendar';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import SuccessModal from '../../shared/SuccessModal';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { TILEPREMISSION_ENDPOINT, CREATETILE_ENDPOINT, UPDATETILE_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
let viewOnly = false;
class MaintainFunction extends React.Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            addFunction: false,
            showFromCalendar: false,
            showToCalendar: false,
            fromCalendar: '',
            toCalendar: '',
            showEditFromCalendar: [],
            showEditToCalendar: [],
            editIndex: '',
            isEdit: [],
            maintainFunctionData: [],
            functionName: '',
            displayName: '',
            meaning: '',
            renderEffectiveCalendar: false,
            renderExpiryCalendar: false,
            confirmedHasOpen: false,
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.onMaintainFunction = this.onMaintainFunction.bind(this);
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({
                showFromCalendar: false, showToCalendar: false,
            });
            this.state.editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
            for (let index = 0; index < this.state.editIndex.length; index++) {
                const element = this.state.editIndex[index];
                let a = this.state.showEditFromCalendar;
                a[element] = false;
                this.setState({ showEditFromCalendar: a })
                let b = this.state.showEditToCalendar;
                b[element] = false;
                this.setState({ showEditToCalendar: b })
            }
        }
    };
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (this.state.maintainFunctionData.map(name => name.function).includes(this.state.functionName)) {
            formIsValid = false;
            toast(message.alert.dublicateFunction, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        if (new Date(this.state.fromCalendar).getFullYear() > new Date(this.state.toCalendar).getFullYear()) {
            formIsValid = false;
            toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
        }
        if (new Date(this.state.fromCalendar).getFullYear() == new Date(this.state.toCalendar).getFullYear()) {
            if (new Date(this.state.fromCalendar).getMonth() > new Date(this.state.toCalendar).getMonth()) {
                formIsValid = false;
                toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
            }
        }
        if (new Date(this.state.fromCalendar).getFullYear() == new Date(this.state.toCalendar).getFullYear()) {
            if (new Date(this.state.fromCalendar).getMonth() == new Date(this.state.toCalendar).getMonth()) {
                if (new Date(this.state.fromCalendar).getDate() > new Date(this.state.toCalendar).getDate()) {
                    formIsValid = false;
                    toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                }
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleEditValidation() {
        let errors = {};
        let formIsValid = true;
        this.state.editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
        for (let index = 0; index < this.state.editIndex.length; index++) {
            const element = this.state.editIndex[index];
            let fromDate = new Date(Number(this.state.maintainFunctionData[element].activeFromDate));
            let toDate = new Date(Number(this.state.maintainFunctionData[element].activeToDate))
            console.log(toDate, toDate.getFullYear(), this.state.maintainFunctionData[element].activeToDate)
            if (this.state.maintainFunctionData[element].activeToDate != 0 && this.state.isEdit[element]) {
                if (fromDate.getFullYear() > toDate.getFullYear()) {
                    formIsValid = false;
                    toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                }
                if (fromDate.getFullYear() == toDate.getFullYear()) {
                    if (fromDate.getMonth() > toDate.getMonth()) {
                        formIsValid = false;
                        toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                    }
                }
                if (fromDate.getFullYear() == toDate.getFullYear()) {
                    if (fromDate.getMonth() == toDate.getMonth()) {
                        if (fromDate.getDate() > toDate.getDate()) {
                            formIsValid = false;
                            toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                        }
                    }
                }
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    validateFormFields = () => {
        return this.state.displayName.length > 0 &&
            this.state.functionName.length > 0 && this.state.fromCalendar.length > 0
    };
    validateEditFormFields = () => {
        let validEdit = [];
        this.state.editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
        for (let index = 0; index < this.state.editIndex.length; index++) {
            const element = this.state.editIndex[index];
            if (this.state.isEdit[element]) {
                validEdit = validEdit.concat(this.state.maintainFunctionData[element].functionDisplayName.length > 0 &&
                    this.state.maintainFunctionData[element].function.length > 0)
            }
        }
        return !validEdit.includes(false)
    };
    onMaintainFunction() {
        this.setState({ addFunction: true });
        document.getElementById('maintainFunctionTable').scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    handleAddFromDateChanged = (e) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        this.setState({ fromCalendar: formatted_date, showFromCalendar: false })
    }
    handleAddToDateChanged = (e) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        this.setState({ toCalendar: formatted_date, showToCalendar: false })
    }
    toggleFromCalendar = () => {
        this.setState({
            showFromCalendar: true,
            renderEffectiveCalendar: true
        });
    };
    toggleToCalendar = () => {
        this.setState({
            showToCalendar: !this.state.showToCalendar,
            renderExpiryCalendar: true
        });
    };
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 1) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
        ApiCall(
            'GET',
            baseURL + TILEPREMISSION_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    console.log(data)
                    this.setState({ maintainFunctionData: data }, () => { console.log(this.state.maintainFunctionData) })
                }
            }
            else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
    }
    getDate = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    romoveAddRow = () => {
        this.setState({
            addFunction: false,
            functionName: '',
            displayName: '',
            meaning: '',
            fromCalendar: '',
            toCalendar: ''
        })
    }
    handleFunctionName = (e) => {
        this.setState({ functionName: e.target.value })
    }
    handleDisplayName = (e) => {
        this.setState({ displayName: e.target.value })
    }
    handleMeaning = (e) => {
        this.setState({ meaning: e.target.value })
    }
    onConfirmMaintainFunction = () => {
        let fromTimeStamp = (new Date(this.state.fromCalendar)).toString().substring(4, 15);
        let toTimeStamp = (new Date(this.state.toCalendar)).toString().substring(4, 15);
        console.log(Date.parse(fromTimeStamp), isNaN(this.state.toCalendar) ? Date.parse(toTimeStamp) : 0)
        console.log(this.state.isEdit.length)
        let editedFunctions = [];
        if (this.state.isEdit.length > 0) {
            if (this.handleEditValidation()) {
                this.state.editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
                for (let index = 0; index < this.state.editIndex.length; index++) {
                    const element = this.state.editIndex[index];
                    if (this.state.isEdit[element] == true) {
                        editedFunctions.push(this.state.maintainFunctionData[element])
                    }
                }
                console.log(editedFunctions, "out")
                ApiCall(
                    'PUT',
                    baseURL + UPDATETILE_ENDPOINT,
                    editedFunctions,
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-cc-trace-id': '1234',
                    }
                ).then(apiData => {
                    if (apiData.flag !== -1) {
                        if (apiData.flag === 500) {
                            if (apiData.data.message != null) {
                                if (apiData.data.message.includes("Unique index")) {
                                    toast(message.alert.dublicateFunction, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                                }
                                else {
                                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                                }
                            }
                            else {
                                toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                            }
                        }
                        else {
                            console.log('I am 200!');
                            this.setState({ confirmedHasOpen: true });
                        }
                    }
                    else {
                        // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                    }
                })
            }
        }
        else {
            if (this.handleValidation()) {
                ApiCall(
                    'POST',
                    baseURL + CREATETILE_ENDPOINT,
                    {
                        "activeFromDate": Date.parse(fromTimeStamp),
                        "activeToDate": isNaN(this.state.toCalendar) ? Date.parse(toTimeStamp) : 0,
                        "function": this.state.functionName,
                        "functionDisplayName": this.state.displayName,
                        "functionMeaning": this.state.meaning,
                        "method": null,
                        "userType": "string"
                    },
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-cc-trace-id': '1234',
                    }
                ).then(data => {
                    if (data.flag !== -1) {
                        if (data.flag === 500) {
                            if (data.data.message === "Function name already exists.") {
                                toast(message.alert.dublicateFunction, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                            }
                            else {
                                toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                            }
                        }
                        else {
                            console.log('I am 200!');
                            this.setState({ confirmedHasOpen: true });
                        }
                    }
                    else {
                        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                    }
                })
            }
        }
    }
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.reload();
    }
    renderTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="col1Heading" className="tableHeading">Function Name</td>
                    <td id="col2Heading" className="tableHeading">Display Name</td>
                    <td id="col3Heading" className="tableHeading">Meaning</td>
                    <td id="col4Heading" className="tableHeading">Active From Date</td>
                    <td id="col5Heading" className="tableHeading">Active To Date</td>
                    <td className="tableHeading" style={{ display: !viewOnly ? "none" : null }}></td>
                </tr>
            </>
        )
    }
    render() {
        const renderTableData = this.state.maintainFunctionData.map((todo, index) => {
            return (
                <>
                    {(!this.state.isEdit[index]) ?
                        <tr key={index} id="maintainFunctiondata">
                            <td id="functionNamecol1" className="maintainFunctiontabledata">{todo.function}</td>
                            <td id="functionNamecol2" className="maintainFunctiontabledata">{todo.functionDisplayName}</td>
                            <td id="functionNamecol3" className="maintainFunctiontabledata">{todo.functionMeaning}</td>
                            <td id="functionNamecol4" className="maintainFunctiontabledata">{
                                todo.activeFromDate == null ? null :
                                    this.getDate(todo.activeFromDate)}</td>
                            <td id="functionNamecol5" className="maintainFunctiontabledata">{todo.activeToDate == 0 ? null : this.getDate(todo.activeToDate)}</td>
                            <td id="functionNamecol6" style={{ display: !viewOnly ? "none" : null }}>
                                <div class="maintainFunctionCol" >
                                    <img
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')}
                                        width="26" height="26" class="d-inline-block pr-1" alt="" loading="lazy"
                                        class="editimagetablefuntion" alt=""
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];
                                            let x = [...this.state.editIndex];
                                            x.push(index)
                                            this.setState({ isEdit: a, editIndex: x }, () => { console.log(this.state.isEdit) });
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                        :
                        <tr className="addFunctionRow"
                            id="maintainFunctiondata"
                        >
                            <td>
                                <input id="functionname" className="tabledata"
                                    value={todo.function}
                                    onChange={(e) => {
                                        this.state.maintainFunctionData[index].function = e.target.value;
                                        this.setState({ maintainFunctionData: this.state.maintainFunctionData })
                                    }}
                                >
                                </input>
                            </td>
                            <td>
                                <input id="displayname" className="tabledata"
                                    value={todo.functionDisplayName}
                                    onChange={(e) => {
                                        this.state.maintainFunctionData[index].functionDisplayName = e.target.value;
                                        this.setState({ maintainFunctionData: this.state.maintainFunctionData })
                                    }}
                                >
                                </input>
                            </td>
                            <td>
                                <input id="functionmeaning" className="tabledata"
                                    value={todo.functionMeaning}
                                    onChange={(e) => {
                                        this.state.maintainFunctionData[index].functionMeaning = e.target.value;
                                        this.setState({ maintainFunctionData: this.state.maintainFunctionData })
                                    }}
                                >
                                </input>
                            </td>
                            <td>
                                <div className="activeDatetinput">
                                    <div class="maintainFunctionCalendarInputBox">
                                        <input class="activeDateInput" placeholder="Select Date"
                                            value={this.getDate(todo.activeFromDate)}
                                        ></input>
                                    </div>
                                    <div class="maintainFunctioncalender">  {this.state.showEditFromCalendar[index] ? <div ref={this.container}> <Calendar
                                        onChange={(e) => {
                                            this.state.maintainFunctionData[index].activeFromDate = Date.parse(e);
                                            let showCalenderone = this.state.showEditFromCalendar;
                                            showCalenderone[index] = false;
                                            this.setState({ maintainFunctionData: this.state.maintainFunctionData, showEditFromCalendar: showCalenderone })
                                        }}
                                        minDate={new Date()} /></div> : null}</div>
                                    <img class="pl-2 pr-2" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" alt=""
                                        onClick={() => {
                                            let a = this.state.showEditFromCalendar;
                                            a[index] = true
                                            let x = [...this.state.editIndex];
                                            x.push(index)
                                            this.setState({ showEditFromCalendar: a, editIndex: x }, () => { console.log(this.state.showEditFromCalendar) });
                                        }}
                                    />
                                </div>
                            </td>
                            <td>
                                <div className="activeDatetinput">
                                    <div class="maintainFunctionCalendarInputBox">
                                        <input class="activeDateInput" placeholder="Select Date"
                                            value={todo.activeToDate == 0 ? null : this.getDate(todo.activeToDate)}
                                        ></input>
                                    </div>
                                    <div class="maintainFunctioncalender" id="expiryDateCalendar">  {this.state.showEditToCalendar[index] ? <div ref={this.container}> <Calendar
                                        onChange={(e) => {
                                            this.state.maintainFunctionData[index].activeToDate = Date.parse(e);
                                            let showCalenderone = this.state.showEditToCalendar;
                                            showCalenderone[index] = false;
                                            this.setState({ maintainFunctionData: this.state.maintainFunctionData, showEditToCalendar: showCalenderone })
                                        }}
                                        minDate={new Date(this.state.maintainFunctionData[index].activeFromDate)}
                                    /></div> : null}</div>
                                    <img class="pl-2 pr-2" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" alt=""
                                        onClick={() => {
                                            let a = this.state.showEditToCalendar;
                                            a[index] = true;
                                            let x = [...this.state.editIndex];
                                            x.push(index)
                                            this.setState({ showEditToCalendar: a, editIndex: x }, () => { console.log(this.state.showEditToCalendar) });
                                        }}
                                    />
                                </div>
                            </td>
                            <td class="maintainfunctioneditcol" id="maintainfunctioneditcoltest">
                                <div class="maintainFunctionCol">
                                    <img
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')}
                                        width="26" height="26" class="d-inline-block pr-1" alt="" loading="lazy"
                                        class="editimagetablefuntion" alt=""
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];
                                            this.setState({ isEdit: a });
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>}
                </>
            )
        });
        console.log(renderTableData)
        return (
            <div className="outer1"><div className="outer1" id="outerdiv">
                <MetaDecorator title={TitleDescription.maintainFunctionPageTitle} description={TitleDescription.maintainFunctionPageDescription} />
                <div className="systemConfigMaintainFunctionContainer" >
                    <SideNav />
                    <div id="systemConfigtPart">
                        <h1 id='maintainFunctionHeadingTitle'>Maintain Function</h1>
                        {/* View Only Access */}
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        <div className="contentbox">
                            <table className="tableHeaderContainer">
                                <tbody>
                                    {this.renderTableHeader()}
                                </tbody>
                            </table>
                            <div id="maintainFunctionTable">
                                <table id='details'>
                                    <tbody>
                                        {this.state.addFunction == true &&
                                            <tr
                                                id="maintainFunctiondata"
                                            >
                                                <td>
                                                    <input id="functionname" className="tabledata" type="text" value={this.state.functionName} onChange={this.handleFunctionName}>
                                                    </input>
                                                </td>
                                                <td>
                                                    <input id="displayname" className="tabledata" type="text" value={this.state.displayName} onChange={this.handleDisplayName}>
                                                    </input>
                                                </td>
                                                <td>
                                                    <input id="functionmeaning" className="tabledata" type="text" value={this.state.meaning} onChange={this.handleMeaning}>
                                                    </input>
                                                </td>
                                                <td>
                                                    <div className="activeDatetinput">
                                                        <div class="maintainFunctionCalendarInputBox">
                                                            <input class="activeDateInput" placeholder="Select Date"
                                                                value={this.state.fromCalendar}
                                                            ></input>
                                                        </div>
                                                        <div class="maintainFunctioncalender">  {this.state.showFromCalendar ? <div ref={this.container}> <Calendar onChange={this.handleAddFromDateChanged} value={this.calenderone} minDate={new Date()} /></div> : null}</div>
                                                        <img class="pl-2 pr-2" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" alt="" onClick={this.toggleFromCalendar}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="activeDatetinput">
                                                        <div class="maintainFunctionCalendarInputBox">
                                                            <input class="activeDateInput" placeholder="Select Date"
                                                                value={this.state.toCalendar}
                                                            ></input>
                                                        </div>
                                                        <div class="maintainFunctioncalender" id="expiryDateCalendar">  {this.state.showToCalendar ? <div ref={this.container}> <Calendar onChange={this.handleAddToDateChanged} value={this.calenderone} minDate={new Date(this.state.fromCalendar)} /></div> : null}</div>
                                                        <img class="pl-2 pr-2" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" alt="" onClick={this.toggleToCalendar}
                                                        />
                                                    </div>
                                                </td>
                                                <td class="maintainfunctioneditcol" id="maintainfunctioneditcoltest">
                                                    <div class="maintainFunctionCol">
                                                        <img class="" src={this.state.addFunction ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')} width="" height="" class="d-inline-block mr-1 " alt="" loading="lazy" alt=""
                                                            onClick={this.romoveAddRow}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        {renderTableData}
                                    </tbody>
                                </table>
                            </div>
                            <hr width="100%" color="#BCBCBC" />
                            <div id="maintainFunctiontableFooter" style={{ display: !viewOnly ? "none" : null }}>
                                <Link onClick={this.onMaintainFunction} to="#maintainFunctiondata"><img src={this.state.addFunction ? addDisable : add} alt="" width="19" height="19" id="maintainfunctionaddrole" /> <small className="addFunctionText" style={{ color: this.state.addFunction ? "#B6B6B6" : "#428BCA" }}>Add Function</small></Link>
                                <div class="functionbtndiv">
                                    <button class="confirmfunctionbtn" disabled={this.state.isEdit.includes(true) ? !this.validateEditFormFields() : !this.validateFormFields()} onClick={this.onConfirmMaintainFunction}><small class="confirmfunctionbtntext">Confirm</small></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                    <p className="confirmedText">Confirmed</p>
                </SuccessModal>
            </div></div>
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(MaintainFunction);